/*
 * Copyright (c) 2026, Wultra s.r.o. (www.wultra.com).
 *
 * All rights reserved. This source code can be used only for purposes specified
 * by the given license contract signed by the rightful deputy of Wultra s.r.o.
 * This source code can be used only by the owner of the license.
 *
 * Any disputes arising in respect of this agreement (license) shall be brought
 * before the Municipal Court of Prague.
 */

import * as v from "valibot"

import { nonBlankString } from "../../utils/non-blank-string"

export const CredentialsSchema = v.object({
    username: nonBlankString("Enter your username"),
    password: nonBlankString("Enter your password")
})

export const TotpSchema = v.object({
    code: nonBlankString("Enter your TOTP code")
})

export type Credentials = v.InferOutput<typeof CredentialsSchema>
